<template>
  <!-- info -->
  <div class="act-info __act-info">
    <h3>
      <!--      好友助力突破
            <span class="free-num">每日下载限制 </span>
            ，<span class="free-num">400次</span>
            免费下载机会等你来拿-->
      <div class="act-step-txt">简单3步：</div>
      <div class="act-step">
        <li class="act-step-item" v-for="(vo,idx) in ACT_STEP">
          <span class="act-step-num">{{ idx + 1 }}</span>
          <span class="act-step-content">{{ vo }}</span>
          <i class="icon_award"></i>
        </li>
      </div>

    </h3>

    <div class="act-link">
      <div class="act-link-text">我的潮国创意专属链接：
        <span class="copy-link ">{{ shareUrl }}</span>
        <span
          class="copy-link clipboardBtn"
          style="position:relative; left: -99999px;"
          data-clipboard-text="复制">
          我发现一个全新的创意图片网站，潮国创意可以免费下载：{{ shareUrl }}
        </span>
      </div>
      <div
        v-show="copyStatus === 0"
        id="ClipboardBtn"
        data-clipboard-target=".clipboardBtn"
        class="act-link-copy"
        @click="copyLink">复制邀请链接
      </div>
      <div
        v-show="copyStatus === 1"
        class="act-link-copy succ"
      >复制成功
      </div>

      <div
        v-show="copyStatus === 2"
        class="act-link-copy succ"
        @click="login"
      >登录
      </div>
    </div>

    <div class="act-link-tip">
      <i class="icon_light"/>
      速成秘籍：点击【复制邀请链接】分享至10人以上微信/QQ等群，以及志同道合的好友，有助于快速获得免费下载权益哦！
    </div>

    <h4>
      <i class="icon_people"/>
      仅需邀请 <span>1人</span> 注册即可解锁 <span>4次</span> 免费下载
    </h4>

    <h5>
      当前已邀请 <span>{{ invitePersonNum || 0 }}人</span>
      <div class="icon_refresh-btn" @click="updateUserMaterialDownload">
        <i class="icon_refresh"></i>刷新
      </div>
    </h5>

    <div class="act-invite-progress">
      <div
        :style=" 'width: ' + barWidth + 'px'"
        class="act-invite-bar"/>
      <div
        v-for="(vo,idx) in awardList"
        :key="idx"
        :class=" { 'on': vo.invite_total <= invitePersonNum } "
        class="act-invite-item"
      >
        <div :class="[ 'ball', { 'on': invitePersonNum >= vo.invite_total }]"/>
        <span class="person-num">{{ vo.invite_total }}人</span>

        <div class="unlock-info-box">
          <div class="unlock-box">
            <i class="icon_unlock"/>
            {{ (vo.invite_total &lt;= invitePersonNum) ? '已' : '未' }}解锁
          </div>

          <div class="unlock-info">
            总下载{{ vo.download_total }}次 <br>
            日下载{{ vo.day_download }}次
          </div>
        </div>
        <i class="discount-coupon" :class="vo.coupon_class"/>
      </div>
    </div>

    <div class="act-received">
      已有
      <span>{{ allNum }}</span>
      位潮国创意用户领取了免费下载次数
    </div>
    <i @click="showInviteDialog" class="icon_record _pointer"/>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import {ACT_STEP, awardList} from './common/module'
import _ from 'lodash'
import {fnInviteFriend, fnLogin} from "@/fn";

export default {
  name: "InviteHeader",
  data() {
    return {
      barWidth: 0,
      awardList,
      ACT_STEP
    }
  },
  props: {
    invitePersonNum: {
      type: Number || String,
      default: 10
    },
    copyStatus: {
      type: Number,
      default: 0
    },
    shareUrl: {
      type: String,
      default: '生成中...'
    },
    allNum: {
      type: Number | String,
      default: 0
    }
  },
  watch: {
    invitePersonNum(val, oldVal) {
      console.log(val)
      val = val > 100 ? 100 : val;

      if (val) {
        let initVal = 78 + 16;  // 初始长度 1长度
        let itemWidth = 177 + 43;    // 单元格长度
        /*
         *    4 3 2 通过当前值所在值区值
         *    20 20 5 2 通过 区间值[+1] - 区间值
         *    30 10 5 1 通过 区间值[-1]
         * */
        if (val > 30) {
          this.barWidth = initVal + itemWidth * 3 + itemWidth / 70 * (val - 30)
        } else if (val > 10) {
          this.barWidth = initVal + itemWidth * 2 + itemWidth / 20 * (val - 10)
        } else if (val > 3) {
          this.barWidth = initVal + itemWidth * 1 + itemWidth / 7 * (val - 3)
        } else if (val > 1) {
          this.barWidth = initVal + itemWidth * 0 + itemWidth / 2 * (val - 1)
        } else if (val > 0) {
          this.barWidth = initVal;
        }
      }


    },
  },
  methods: {
    copyLink: _.throttle(function () {
      let clipboard = new Clipboard('#ClipboardBtn')
      clipboard.on('success', e => {
        this.$myNotify.success("复制成功")
        this.updateCopyStatus(1)
        setTimeout(() => {
          this.updateCopyStatus(0)
        }, 2000)

        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$myNotify.show('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    }),
    login() {
      this.$store.commit('user/SET_IS_SHOW_LOGIN', true);
    },
    showInviteDialog() {
      this.$emit('showInviteDialog')
    },
    updateCopyStatus(val) {
      this.$emit('updateCopyStatus', val)
    },
    updateUserMaterialDownload: _.throttle(function () {
      if (fnLogin.checkLogin()) {
        this.$store.dispatch('user/getMaterialFreeDownloadNum');
        this.$emit('updateUserMaterialDownload')
        this.$myNotify.success('刷新成功')
      } else {
        fnLogin.loginIntercept(false)
      }
    }, 3000),
  }
}
</script>

<style lang="scss" scoped>
@import "./common/common";

.act-info {
  .icon_record {
    @include BgImage(38px, 84px, 'act/invite-friends/invite-text.png');
    @include Position(1, 2, -62px, 344px);
  }

  h3 {

    .act-step-txt {
    }
  }

  h4 {
    margin-bottom: 15px;
  }

  h5 {
    height: 24px;
    font-size: 20px;
    font-weight: bold;
    color: #20395B;
    line-height: 24px;
    letter-spacing: 6px;
    margin-bottom: 144px;
    display: flex;

    span {
      color: #F36A50;
    }

  }
}

.icon_refresh-btn {
  width: 80px;
  height: 30px;
  background: #F36A50 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  border-radius: 35px;
  font-size: 15px;
  color: #FFFFFF;
  cursor: pointer;
  @include ElementHover('', rgba(243, 106, 80, 0.8));
}

.icon_refresh {
  @include BgImage(18px, 18px, 'login/icon_ refresh-1.png');
  margin-right: 6px;
}


</style>
